import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildRequestHeaders,
} from "utils/helpers";

const queryFn = (
    accessToken: string,
    data: {
        reportFiltersetUid: string | null;
    }
    ) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {
            reportFiltersetUid: data.reportFiltersetUid,
        }, 
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => {
        if (data.prefilteredReports?.prefilteredBaselineReport?.cumulativeCarbonEmissionsCard.error)
            throw new Error(
            // eslint-disable-next-line max-len
                data.prefilteredReports.prefilteredBaselineReport.cumulativeCarbonEmissionsCard.error
            );
        return (
            (data.prefilteredReports?.prefilteredBaselineReport
                ?.cumulativeCarbonEmissionsCard as CumulativeCarbonEmissionsCardData) ||
            null
        );
    });

const query = graphql(`
    query cumulativeCarbonEmissionsCard($reportFiltersetUid: Uuid) {
        prefilteredReports(reportFiltersetUid: $reportFiltersetUid) {
            prefilteredBaselineReport {
                cumulativeCarbonEmissionsCard {
                    error
                    totalCarbonEmissions
                    totalCarbonEmissionsElectricity
                    totalCarbonEmissionsNaturalGas
                }
            }
        }
    }
`);

export default queryFn;
